import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';


@Component({
  selector: 'ngbtypeofpatient',
  templateUrl: './typeofpatient.modal.html',
  styleUrls: ['./typeofpatient.modal.scss']
})

export class NgbTypeofPatientModal implements OnInit {
  
  
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit() {



  }

  onSubmit() {

  }
  ModalClose() {
    this.activeModal.close();
  }
  
  



}
